module.exports = __webpack_public_path__ + "static/img/7.ed547cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/hospital1/7.png
// module id = mrDz
// module chunks = 1